// Restep — scripts propios. Un init por componente, todos desde DOMContentLoaded.
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.rs-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('rs-visible'); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute('data-rs-delay') || '0', 10);
            setTimeout(function () { el.classList.add('rs-visible'); }, delay);
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initContadores() {
    var els = document.querySelectorAll('.rs-cuenta[data-target]');
    if (!els.length) return;
    var animado = new WeakSet();
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || animado.has(entry.target)) return;
          animado.add(entry.target);
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-target')) || 0;
          var suffix = el.getAttribute('data-suffix') || '';
          var decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
          var dur = 1400;
          var start = null;
          function paso(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / dur, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            el.textContent = (target * eased).toFixed(decimals) + suffix;
            if (p < 1) requestAnimationFrame(paso);
          }
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            el.textContent = target.toFixed(decimals) + suffix;
          } else {
            requestAnimationFrame(paso);
          }
          obs.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );
    els.forEach(function (el) { obs.observe(el); });
  }

  function initGaleriaProducto() {
    document.querySelectorAll('[data-rs-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-rs-imagen-principal]');
      var minis = galeria.querySelectorAll('[data-rs-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var srcset = mini.getAttribute('data-full-srcset');
          if (src) principal.src = src;
          if (srcset) principal.srcset = srcset;
          minis.forEach(function (m) { m.classList.remove('rs-mini--activa'); });
          mini.classList.add('rs-mini--activa');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-rs-producto-form]').forEach(function (form) {
      var variantesJson = form.querySelector('[data-rs-variantes]');
      if (!variantesJson) return;
      var variantes;
      try { variantes = JSON.parse(variantesJson.textContent); } catch (e) { return; }
      var selects = form.querySelectorAll('[data-rs-opcion]');
      var idInput = form.querySelector('input[name="id"]');
      var precioEl = form.querySelector('[data-rs-precio]');
      var compareEl = form.querySelector('[data-rs-precio-comparado]');
      var boton = form.querySelector('[data-rs-add]');
      var agotadoTexto = form.getAttribute('data-texto-agotado') || 'Agotado';
      var disponibleTexto = form.getAttribute('data-texto-disponible') || 'Añadir al carrito';

      function moneda(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
        });
      }

      function actualizar() {
        if (!selects.length) return;
        var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variantes.find(function (v) {
          return v.options.every(function (opt, i) { return opt === valores[i]; });
        });
        if (!match) return;
        idInput.value = match.id;
        if (precioEl) precioEl.textContent = moneda(match.price);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = moneda(match.compare_at_price);
            compareEl.style.display = '';
          } else {
            compareEl.style.display = 'none';
          }
        }
        if (boton) {
          boton.disabled = !match.available;
          boton.textContent = match.available ? disponibleTexto : agotadoTexto;
        }
      }

      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
      actualizar();
    });
  }

  function initBundles() {
    document.querySelectorAll('[data-rs-bundles]').forEach(function (grupo) {
      var radios = grupo.querySelectorAll('[data-rs-bundle-radio]');
      if (!radios.length) return;
      var form = grupo.closest('[data-rs-producto-form]');
      var cantidadInput = form ? form.querySelector('[data-rs-cantidad]') : null;

      function aplicar(radio) {
        radios.forEach(function (r) {
          r.closest('.rs-prod__bundle').classList.toggle('rs-prod__bundle--activa', r === radio);
        });
        if (cantidadInput) cantidadInput.value = radio.getAttribute('data-pares') || '1';
      }

      radios.forEach(function (radio) {
        radio.addEventListener('change', function () { aplicar(radio); });
      });

      var marcado = grupo.querySelector('[data-rs-bundle-radio]:checked') || radios[0];
      if (marcado) { marcado.checked = true; aplicar(marcado); }
    });
  }

  function initStickyAtc() {
    var barra = document.querySelector('[data-rs-sticky-atc]');
    var boton = document.querySelector('[data-rs-add]');
    var stickyBoton = document.querySelector('[data-rs-sticky-boton]');
    if (!barra || !boton) return;
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          barra.classList.toggle('rs-prod__sticky--visible', visible);
          document.body.style.paddingBottom = visible ? barra.offsetHeight + 'px' : '';
        });
      },
      { threshold: 0 }
    );
    obs.observe(boton);
    if (stickyBoton) {
      stickyBoton.addEventListener('click', function () {
        var form = boton.closest('form');
        if (form) form.requestSubmit(boton);
      });
    }
  }

  function initAntesDespues() {
    document.querySelectorAll('[data-rs-slider]').forEach(function (wrap) {
      var range = wrap.querySelector('[data-rs-range]');
      if (!range) return;
      var dragging = false;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        range.value = pct;
        wrap.style.setProperty('--rs-ad-pos', pct + '%');
      }

      function posFromEvent(e) {
        var r = wrap.getBoundingClientRect();
        var x = e.clientX - r.left;
        return (x / r.width) * 100;
      }

      wrap.addEventListener('pointerdown', function (e) {
        dragging = true;
        if (wrap.setPointerCapture) { try { wrap.setPointerCapture(e.pointerId); } catch (err) {} }
        setPos(posFromEvent(e));
        e.preventDefault();
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(posFromEvent(e));
      });
      ['pointerup', 'pointercancel'].forEach(function (evt) {
        wrap.addEventListener(evt, function () { dragging = false; });
      });

      range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
      setPos(parseFloat(range.value) || 50);
    });
  }

  function initCountdown() {
    document.querySelectorAll('[data-rs-countdown]').forEach(function (el) {
      var targetStr = el.getAttribute('data-target');
      var target = new Date(targetStr).getTime();
      var wrap = el.closest('[data-rs-oferta-timer]');
      if (!targetStr || isNaN(target)) { if (wrap) wrap.style.display = 'none'; return; }
      var hEl = el.querySelector('[data-rs-h]');
      var mEl = el.querySelector('[data-rs-m]');
      var sEl = el.querySelector('[data-rs-s]');
      var timer;
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00';
          clearInterval(timer);
          return;
        }
        hEl.textContent = pad(Math.floor(diff / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick();
      timer = setInterval(tick, 1000);
    });
  }

  function initUsos() {
    document.querySelectorAll('[data-rs-usos]').forEach(function (slider) {
      var pista = slider.querySelector('[data-rs-usos-pista]');
      var tarjetas = slider.querySelectorAll('[data-rs-usos-tarjeta]');
      var puntos = slider.querySelectorAll('[data-rs-usos-punto]');
      var btnPrev = slider.querySelector('[data-rs-usos-prev]');
      var btnNext = slider.querySelector('[data-rs-usos-next]');
      if (!pista || !tarjetas.length) return;

      function pasoScroll() {
        return (tarjetas[0].getBoundingClientRect().width || 0) + 16;
      }

      function actualizarPuntos() {
        if (!puntos.length) return;
        var centro = pista.scrollLeft + pista.clientWidth / 2;
        var indiceActivo = 0;
        var distanciaMin = Infinity;
        tarjetas.forEach(function (tarjeta, i) {
          var centroTarjeta = tarjeta.offsetLeft + tarjeta.offsetWidth / 2;
          var distancia = Math.abs(centro - centroTarjeta);
          if (distancia < distanciaMin) { distanciaMin = distancia; indiceActivo = i; }
        });
        puntos.forEach(function (p, i) { p.classList.toggle('rs-usos__punto--activo', i === indiceActivo); });
      }

      if (btnPrev) btnPrev.addEventListener('click', function () { pista.scrollBy({ left: -pasoScroll(), behavior: 'smooth' }); });
      if (btnNext) btnNext.addEventListener('click', function () { pista.scrollBy({ left: pasoScroll(), behavior: 'smooth' }); });

      puntos.forEach(function (punto, i) {
        punto.addEventListener('click', function () {
          pista.scrollTo({ left: tarjetas[i].offsetLeft - pista.offsetLeft, behavior: 'smooth' });
        });
      });

      var arrastrando = false;
      var origenX = 0;
      var origenScroll = 0;
      var movido = false;

      pista.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        movido = false;
        origenX = e.clientX;
        origenScroll = pista.scrollLeft;
        pista.classList.add('rs-usos__pista--arrastrando');
        if (pista.setPointerCapture) { try { pista.setPointerCapture(e.pointerId); } catch (err) {} }
      });
      pista.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        var delta = e.clientX - origenX;
        if (Math.abs(delta) > 4) movido = true;
        pista.scrollLeft = origenScroll - delta;
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        pista.addEventListener(evt, function () {
          arrastrando = false;
          pista.classList.remove('rs-usos__pista--arrastrando');
        });
      });
      pista.addEventListener('click', function (e) {
        if (movido) { e.preventDefault(); e.stopPropagation(); movido = false; }
      });

      var pistaScrollTimeout;
      pista.addEventListener('scroll', function () {
        clearTimeout(pistaScrollTimeout);
        pistaScrollTimeout = setTimeout(actualizarPuntos, 60);
      });
      actualizarPuntos();
    });
  }

  function initFaq() {
    document.querySelectorAll('[data-rs-faq-item]').forEach(function (item) {
      var pregunta = item.querySelector('[data-rs-faq-pregunta]');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierto = item.classList.contains('rs-faq-item--abierta');
        item.closest('[data-rs-faq]').querySelectorAll('[data-rs-faq-item]').forEach(function (i) {
          i.classList.remove('rs-faq-item--abierta');
        });
        if (!abierto) item.classList.add('rs-faq-item--abierta');
      });
    });
  }

  function initTiltHover() {
    if (window.matchMedia('(pointer: coarse)').matches) return;
    document.querySelectorAll('[data-rs-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform = 'perspective(700px) rotateY(' + (x * 6) + 'deg) rotateX(' + (y * -6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initGaleriaProducto();
    initVariantes();
    initBundles();
    initStickyAtc();
    initAntesDespues();
    initUsos();
    initCountdown();
    initFaq();
    initTiltHover();
  });
})();
